import script from "./HDFHeader03.vue?vue&type=script&setup=true&lang=js"
export * from "./HDFHeader03.vue?vue&type=script&setup=true&lang=js"

import "./HDFHeader03.vue?vue&type=style&index=0&id=d1bfa3c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1bfa3c8"]])

export default __exports__